import { MintType } from "../../types/Types"
import Mint from "./Mint"

const Close = () => {
  return <Mint tabs={[MintType.CLOSE]} />
}

export default Close
